import { DATA_STATES } from '@/store/consts';

const STATE_KEYS = {
  DATA_STATE: 'dataState',
  MEDALLIA_INITIALIZATION_INFO: 'medalliaInitializationInfo',
  LAST_UPDATE_TIME: 'lastUpdateTime',
  ERROR_COUNT: 'errorCount',
  CONFIGURATION_STEP: 'configurationStep',
  SKILLS: 'skills',
  SKILLS_LOADING: 'skillsLoadingFlag',
  SURVEYS: 'surveys',
  SURVEYS_LOADING: 'surveysLoadingFlag',
  CONFIG_SURVEY_INFO: 'configSurveyInfo',
};

const defaultState = {
  [STATE_KEYS.DATA_STATE]: DATA_STATES.NONE,
  [STATE_KEYS.MEDALLIA_INITIALIZATION_INFO]: {},
  [STATE_KEYS.CONFIGURATION_STEP]: 0,
  [STATE_KEYS.SKILLS]: [],
  [STATE_KEYS.SKILLS_LOADING]: DATA_STATES.NONE,
  [STATE_KEYS.SURVEYS]: [],
  [STATE_KEYS.CONFIG_SURVEY_INFO]: [
    {
      title: 'MEDALLIA_PAGE_ID', info: '', placeholder: 'Enter ID', label: 'Medallia Page ID', tooltip: 'Unique identifier for the channel to be provided to LivePerson. This can be be found when you click on the LivePerson channel in Medallia.',
    },
    {
      title: 'MEDALLIA_CHANNEL_ID', info: '', placeholder: 'For example: 9b1b0210-ced0-11eb-8753-a5b515bd8798', label: 'Medallia Channel ID', tooltip: 'Unique channel ID that is generated once the channel has been setup in Medallia. This can be be found when you click on the LivePerson channel in Medallia.',
    },
    {
      title: 'MEDALLIA_API_BASED_URL', info: '', placeholder: 'Enter in http:// format', label: 'Medallia API Based URL', tooltip: 'Inbound Webhook URL from Medallia. This can be be found when you click on the LivePerson channel in Medallia.',
    },
    {
      title: 'CLIENT_ID', info: '', placeholder: 'Enter client ID', label: 'Client ID', tooltip: 'Please use the Client ID that is setup in the Medallia Inbound Auth Settings in the Channel on Medallia.',
    },
    {
      title: 'CLIENT_SECRET', info: '', placeholder: 'Enter client secret', label: 'Client Secret', tooltip: 'Please use the Client ID that is setup in the Medallia Inbound Auth Settings in the Channel on Medallia.',
    },
    { label: 'interactivenessOn', info: false },
    { label: 'agentMessageCount', info: 4 },
    { label: 'consumerMessageCount', info: 4 },
  ],
  [STATE_KEYS.SURVEYS_LOADING]: DATA_STATES.NONE,
  [STATE_KEYS.SELECTED_SURVEYS_SKILLS]: {},
};

const state = {
  [STATE_KEYS.DATA_STATE]: DATA_STATES.NONE,
  [STATE_KEYS.MEDALLIA_INITIALIZATION_INFO]: {},
  [STATE_KEYS.CONFIGURATION_STEP]: 0,
  [STATE_KEYS.SKILLS]: [],
  [STATE_KEYS.SKILLS_LOADING]: DATA_STATES.NONE,
  [STATE_KEYS.SURVEYS]: [],
  [STATE_KEYS.CONFIG_SURVEY_INFO]: [
    {
      title: 'MEDALLIA_PAGE_ID', info: '', placeholder: 'Enter ID', label: 'Medallia Page ID', tooltip: 'Unique identifier for the channel to be provided to LivePerson. This can be be found when you click on the LivePerson channel in Medallia.',
    },
    {
      title: 'MEDALLIA_CHANNEL_ID', info: '', placeholder: 'For example: 9b1b0210-ced0-11eb-8753-a5b515bd8798', label: 'Medallia Channel ID', tooltip: 'Unique channel ID that is generated once the channel has been setup in Medallia. This can be be found when you click on the LivePerson channel in Medallia.',
    },
    {
      title: 'MEDALLIA_API_BASED_URL', info: '', placeholder: 'Enter in http:// format', label: 'Medallia API Based URL', tooltip: 'Inbound Webhook URL from Medallia. This can be be found when you click on the LivePerson channel in Medallia.',
    },
    {
      title: 'CLIENT_ID', info: '', placeholder: 'Enter client ID', label: 'Client ID', tooltip: 'Please use the Client ID that is setup in the Medallia Inbound Auth Settings in the Channel on Medallia.',
    },
    {
      title: 'CLIENT_SECRET', info: '', placeholder: 'Enter client secret', label: 'Client Secret', tooltip: 'Please use the Client ID that is setup in the Medallia Inbound Auth Settings in the Channel on Medallia.',
    },
    { label: 'interactivenessOn', info: false },
    { label: 'agentMessageCount', info: 4 },
    { label: 'consumerMessageCount', info: 4 },
  ],
  [STATE_KEYS.SURVEYS_LOADING]: DATA_STATES.NONE,
  [STATE_KEYS.SELECTED_SURVEYS_SKILLS]: {},
};


export {
  defaultState,
  state,
  STATE_KEYS,
};
